import React, { useEffect, useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import QuestionInput from "./QuestionInput";
import { buildValidationSchema } from "./validationBuilder";
import "./questionnaire.css";

export default function QuestionnaireRenderer({
    questionnaire,
    answers: initialAnswers = [],
    onAnswer,
    source,
    oldMachineResponse,
    totalQuestions,
    answeredCount,
}) {
    const [machineResponse, setMachineResponse] = useState(oldMachineResponse);
    const [answeredList, setAnsweredList] = useState([]);
    const [endScreen, setEndScreen] = useState(null);


    useEffect(() => {
        setMachineResponse(oldMachineResponse);
    }, [oldMachineResponse]);

    /* --------------------------------
       INITIALIZE MACHINE FROM ANSWERS
    -------------------------------- */
    useEffect(() => {

        if (!questionnaire) return;
        // trust backend answers only
        setAnsweredList(initialAnswers);

        // If answers already exist and outcome exists → UI-only display
        const finalAnswer = initialAnswers.find(a => a.outcome != null);
        if (finalAnswer) {
            setEndScreen({
                title: finalAnswer.outcome,
                description: finalAnswer.outcome_description ?? "",
                status:
                    finalAnswer.outcome === "Eligible" ||
                    finalAnswer.outcome === "Complete"
            });
            return;
        }

    }, [questionnaire, initialAnswers]);


    /* --------------------------------
       HANDLE SUBMIT
    -------------------------------- */
    const handleSubmit = ({ answer }) => {

        const question = machineResponse.question;

        let finalAnswer = answer;

        // If optional and empty → treat as "--"
        if (!question.required && (!answer || answer.trim() === "")) {
            finalAnswer = "--";
        }

        // If required and empty → stop (Formik should already handle this)
        if (question.required && (!answer || answer.trim() === "")) {
            return;
        }
        onAnswer({
            questionnaireId: questionnaire.id,
            source,
            answer: finalAnswer
        });
    };;

    /* --------------------------------
       RENDER
    -------------------------------- */

    return (
        <div className="questionnaire-wrapper">
            {/* Answer history (from backend only) */}
            <div className="answered-list">
                {[...answeredList]
                    .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
                    .map(a => (
                        <div key={a.id} className="answered-item">
                            <div className="answered-question">{a.question}</div>
                            <div className="answered-answer">{a.answer}</div>
                        </div>
                    ))}
            </div>

            {/* Outcome */}
            {endScreen && (
                <div
                    className={`result-screen ${endScreen.status ? "success" : "disqualified"
                        }`}
                >
                    <div className="result-card">
                        <h5>{endScreen.title}</h5>
                        {endScreen.description && (
                            <p>{endScreen.description}</p>
                        )}
                    </div>
                </div>
            )}

            {/* Question */}
            {machineResponse?.type === "question" && (
                <> {/* Progress */}
                    <div className="progress-container">
                        <div className="progress-label">
                            Question {answeredCount + 1} of {totalQuestions}
                        </div>
                        <div className="progress-bar">
                            <div
                                className="progress-fill"
                                style={{
                                    width: `${((answeredCount + 1) / totalQuestions) * 100}%`,

                                }}
                            />
                        </div>
                    </div>
                    <Formik
                        key={machineResponse?.question.id}
                        initialValues={{ answer: "" }}
                        validationSchema={buildValidationSchema(
                            machineResponse?.question
                        )}
                        onSubmit={handleSubmit}
                    >
                        {formik => (
                            <Form>
                                <h6>{machineResponse?.question.label}</h6>

                                <QuestionInput
                                    question={machineResponse?.question}
                                    formik={formik}
                                />

                                <ErrorMessage
                                    name="answer"
                                    component="div"
                                    className="error"
                                />

                                <button type="submit" className="next-btn">
                                    Continue
                                </button>
                            </Form>
                        )}
                    </Formik>
                </>
            )}
        </div>
    );
}
